import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=a52620ce&scoped=true&"
import script from "./UserManager.vue?vue&type=script&lang=js&"
export * from "./UserManager.vue?vue&type=script&lang=js&"
import style0 from "./UserManager.vue?vue&type=style&index=0&id=a52620ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52620ce",
  null
  
)

export default component.exports